import { render, staticRenderFns } from "./InboundRoute.vue?vue&type=template&id=33b1ae4c"
import script from "./InboundRoute.vue?vue&type=script&lang=js"
export * from "./InboundRoute.vue?vue&type=script&lang=js"
import style0 from "./InboundRoute.vue?vue&type=style&index=0&id=33b1ae4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports